import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/Container.css';

export default function Jurisdiction() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const reason = params.get('reason');

    useEffect(() => {
        document.title = "Access Denied"
    }, []);

    const getMessage = () => {
        switch(reason) {
            case 'iwf':
                return 'indecent images of children as identified by the Internet Watch Foundation.';
            case 'ctiru':
                return 'content as identified by the Counter-Terrorism Internet Referral Unit.';
            default:
                return 'content restricted in your local jurisdiction.';
        }
    };

    return (
        <div style={{margin: "auto", width: "50%"}}>
            <p style={{textAlign: "justify"}}>
                Access has been denied by your internet access provider because this
                page may contain {getMessage()}
            </p>
        </div>
    )
}
